'use client'

import { createContext } from 'react'

import { FacetedCategoryDto } from 'types/dtos/catalog'

export type ContextType = {
  categories: Array<FacetedCategoryDto> | undefined
}

const Context = createContext<ContextType>({ categories: undefined })

export default Context
